// 방문경로 — 잠재회원·상담이 공유한다. 백엔드 VisitPath enum 과 값·순서를 맞춘다.
// 온라인 → 발송·알림 → 오프라인 광고 → 소개 순.
export const VISIT_PATH_LABELS = {
  NAVER_BLOG: '네이버블로그',
  INSTAGRAM: '인스타',
  HOMEPAGE: '홈페이지',
  WEB_SEARCH: '웹서핑',
  COMMUNITY: '커뮤니티',
  DAANGN: '당근',
  KAKAO_CHANNEL: '카카오채널',
  ALIMTALK: '알림톡',
  PUSH: '푸시알림',
  SMS: '문자',
  SIGNBOARD: '간판·현수막',
  BANNER: '배너',
  FLYER: '전단',
  AD_MATERIAL: '광고물',
  STAFF_REFERRAL: '직원소개',
  FRIEND_REFERRAL: '지인추천',
  OTHER: '기타',
};

// 기타 — 고르면 직접 입력란이 열린다. 필터·통계는 기타 한 묶음.
export const VISIT_PATH_OTHER = 'OTHER';
export const VISIT_PATH_ETC_MAX_LENGTH = 20;

export const VISIT_PATH_OPTIONS = Object.entries(VISIT_PATH_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const getVisitPathLabel = visitPath => VISIT_PATH_LABELS[visitPath] || visitPath || '-';

// 기타 + 직접 입력 글이면 '기타(글)', 그 외는 라벨만.
export const formatVisitPath = (visitPath, visitPathEtc) =>
  visitPath === VISIT_PATH_OTHER && visitPathEtc
    ? `${getVisitPathLabel(visitPath)}(${visitPathEtc})`
    : getVisitPathLabel(visitPath);
